import BootstrapTableModule from 'react-bootstrap-table-next';

const unwrapDefault = (module) => module.default ?? module;

export const BootstrapTable = unwrapDefault(BootstrapTableModule);
